<p>{{'infoDialog p1' | translate}}<br><br>
    
    {{'infoDialog p2' | translate}}
    </p>
